module.exports = __webpack_public_path__ + "img/card_1.5ef552e4.jpeg";